import { render, staticRenderFns } from "./ScanPay.vue?vue&type=template&id=0b1b4926&scoped=true&"
import script from "./ScanPay.vue?vue&type=script&lang=js&"
export * from "./ScanPay.vue?vue&type=script&lang=js&"
import style0 from "./ScanPay.vue?vue&type=style&index=0&id=0b1b4926&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1b4926",
  null
  
)

component.options.__file = "ScanPay.vue"
export default component.exports